module.exports = __webpack_public_path__ + "img/Edit Icon - charcoal.59263ac6.svg";